import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import { UniFiChildCategorySlug } from '../../../proStoreCategories/mapping/unifi.mjs';
import '../../assets/Assets-V4/Switching/pro-max-24@2x.jpg.mjs';
import '../../assets/Switching/professionalMax24.jpg.mjs';
import { twoPointFiveTenGigabitEthernet } from '../product-groups/switching/2.5-10-gbe-1u.mjs';
import { professionalMax } from '../product-groups/twoPointFiveTenGigabitEthernet/professional-max.mjs';
import { productListSwitchingProfessional } from '../product-list-groups/productListSwitchingProfessional.mjs';
import '../properties/index.mjs';
import { portCount } from '../properties/portCount.mjs';
import { downlinkSpeed } from '../properties/downlinkSpeed.mjs';
import { uplinkSpeed } from '../properties/uplinkSpeed.mjs';
import { poeOutput } from '../properties/poeOutput.mjs';
import { poeAvailability } from '../properties/poeAvailability.mjs';
import { proAvSupport } from '../properties/proAvSupport.mjs';
import { mounting } from '../properties/mounting.mjs';
import { outdoorReady } from '../properties/outdoorReady.mjs';
import { switchTechnology } from '../properties/switchTechnology.mjs';
import { etherlighting } from '../properties/etherlighting.mjs';
import { powerMethod } from '../properties/powerMethod.mjs';
import v3Image__default from "../../../../assets/professionalMax24.jpg";
import image__default from "../../../../assets/pro-max-24@2x.jpg";
"use strict";
const professionalMax24 = {
  id: "professionalMax24",
  title: "professionalMax24.title",
  description: "professionalMax24.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-pro-max-24"],
  storePathParts: {
    productSlug: "usw-pro-max-24",
    category: UniFiChildCategorySlug.SwitchingProfessionalMaxXg
  },
  sku: "USW-Pro-Max-24",
  image: {
    src: image__default,
    width: 200,
    height: 140
  },
  v3Image: {
    src: v3Image__default,
    width: 294,
    height: 120
  },
  productListGroup: productListSwitchingProfessional,
  productGroup: twoPointFiveTenGigabitEthernet,
  secondaryProductGroup: professionalMax,
  propertyValues: [{
    propertyId: "dimensions",
    value: {
      type: "string",
      value: '442 x 325 x 44 mm\n(17.4 x 12.8 x 1.7")'
    }
  }, {
    propertyId: portCount.id,
    value: {
      type: "string",
      value: "24 + 2 SFP+"
    }
  }, {
    propertyId: downlinkSpeed.id,
    value: {
      type: "translation",
      value: "commons.speed.upTo2_5Gbps"
    }
  }, {
    propertyId: uplinkSpeed.id,
    value: {
      type: "string",
      value: "10 Gbps"
    }
  }, {
    propertyId: poeOutput.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: poeAvailability.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: proAvSupport.id,
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: "generalRedundancy",
    value: {
      type: "translation",
      value: "commons.powerRedundancy.unifiPowerBackupReady"
    }
  }, {
    propertyId: mounting.id,
    value: {
      type: "translation",
      value: "commons.mounting.rack"
    }
  }, {
    propertyId: outdoorReady.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: switchTechnology.id,
    value: {
      type: "translation",
      value: "commons.switchingTechnology.layer3"
    }
  }, {
    propertyId: etherlighting.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: powerMethod.id,
    value: {
      type: "translation",
      value: "commons.powerMethod.acPower"
    }
  }]
};
export { professionalMax24 };
//# sourceMappingURL=professionalMax24.mjs.map
